import { configureStore } from '@reduxjs/toolkit';
import loginSlice from '../features/loginSlice';
import dashboardSlice from '../features/dashboardSlice';
import assignGridSlice from '../features/assignGridSlice';
import onboardingSlice from '../features/onboardingSlice';
import taskSlice from '../features/taskSlice';
import trackLocationSlice from '../features/trackLocationSlice';
import leadSlice from '../features/leadSlice';
import setTargetSlice from '../features/setTargetSlice';
import locationFilterSlice from '../features/locationFilterSlice';
import reimbursementSlice from '../features/reimbursementSlice';
import attendanceSlice from '../features/attendanceSlice';
import marketingActivitySlice from '../features/marketingActivitySlice';
import remunerationSlice from '../features/remunerationSlice';
import trackComplaintsSlice from '../features/trackComplaintsSlice';
import bannerSlice from '../features/bannerSlice';
import knowledgeCenterSlice from '../features/knowledgeCenterSlice';
import gallerySlice from '../features/gallerySlice';
import latestUpdatesSlice from '../features/latestUpdatesSlice';
import welcomeVideosSlice from '../features/welcomeVideosSlice';
import employeeDataSlice from '../features/employeeDataSlice';
import notificationSlice from '../features/notificationSlice';
import claimSearchSlice from '../features/claimSearchSlice';

export const store = configureStore({
  reducer: {
    login: loginSlice,
    dashboard: dashboardSlice,
    assignGrid: assignGridSlice,
    onboarding: onboardingSlice,
    task: taskSlice,
    lead: leadSlice,
    trackLocation: trackLocationSlice,
    setTarget: setTargetSlice,
    locationFilter: locationFilterSlice,
    reimbursement: reimbursementSlice,
    attendance: attendanceSlice,
    marketingActivity: marketingActivitySlice,
    remuneration: remunerationSlice,
    trackComplaints: trackComplaintsSlice,
    banner: bannerSlice,
    knowledgeCenter: knowledgeCenterSlice,
    gallery: gallerySlice,
    latestUpdates: latestUpdatesSlice,
    welcomeVideos: welcomeVideosSlice,
    employeeData: employeeDataSlice,
    notification: notificationSlice,
    claimSearch: claimSearchSlice,
  },
});
